import { LocationItem } from '@zayan-erp/home-building';

export interface warrantyTypes {
  id: string;
  typeCode: string;
  typeName: string;
  daysToClose: number;
  inActive: boolean;
}

export type WarrantyLocation = Omit<LocationItem, 'locationName'> & { location: string };

export interface WarrantyCategory {
  id: string;
  categoryCode: string;
  categoryDescription: string;
  createdAt: string;
  inActive: boolean;
  locations: WarrantyLocation[];
  locationsCount?: number;
}
export interface WarrantyUserDto {
  roleId: string;
  projectIds: string[];
  warrantyTypeIds: string[];
}

export interface WarrantyDeficiency {
  categoryCode: string;
  categoryDescription: string;
  categoryId: string;
  craftCode: string;
  craftDescription: string;
  craftId: string;
  deficiencyCode: string;
  deficiencyDescription: string;
  id: string;
  inActive: boolean;
}

export interface WarrantyCraft {
  craftCode: string;
  craftDescription: string;
  id: string;
  inActive: boolean;
}

export interface WarrantyOption {
  id: string;
  projectCode: string;
  lotNo: string;
  extraNo: string | null;
  extraItem: string | null;
  productCode: string | null;
  productDescription: string | null;
  memo: string | null;
  quantity: number;
  unitPrice: number;
  tax: number;
  discount: number;
  total: number;
}

export enum WarrantyWorkOrderStatus {
  InProcess = 'In Process',
  NotStarted = 'Not Started',
  Completed = 'Completed',
  Escalated = 'Escalated',
  Cancelled = 'Cancelled'
}

export interface SchedulerLotDeficiencies {
  scheduledDate: string;
  lotNo: string;
  LotDeficiencies: LotDeficiency[];
}

export interface LotDeficiency {
  id: string;
  lotId: string;
  lotNo: string;
  projectId: string;
  projectName: string;
  warrantyTypeId: string;
  deficiencyCode: string;
  deficiencyDescription?: string;
  deficiencyId: string;
  locationId: string;
  location: string;
  locationCode: string;
  detailDescription?: string;
  assignedToTrade?: string;
  assignedToTechnician?: string;
  scheduledDate?: string;
  completedDate?: string;
  status: WarrantyWorkOrderStatus;
  keyImages: Record<string, string>;
  technicianName: string | null;
  tradeCode: string | null;
  tradeName: string | null;
  typeCode: string;
  typeName: string;
  isEscalated?: boolean;
  assignments?: DeficiencyAssignment[];
  warrantyName?: string;
  warrantyCode?: string;
}

export interface LotDeficiencyUpdateDto {
  scheduledDate: string;
  detailDescription?: string;
  assignedToTechnician?: string;
  assignedToTrade?: string;
  enableInstantEmail: boolean;
}

export interface LotDeficiencyImage {
  url: string;
  s3Key: string;
}

export interface LotOption {
  id: string;
  lotNo: string;
  memo: string;
  productCode: string;
  productDescription: string;
  projectCode: string;
  quantity: number;
  tax: number;
  total: number;
  unitPrice: number;
  discount: number;
  extraItem: string;
  extraNo: string;
}
export interface XmlDeficiency {
  description: string;
  location: string;
  level: string;
  room: string;
  category: string;
  deficiencyCode: string;
  // numbers: string[];
}
export interface WorkOrder {
  // projectCode?:string,
  lotNo: string;
  warrantyType: string;
  deficiencies: XmlDeficiency[];
  // isValid: boolean;
}

export interface WorkOrderImportTableItem {
  lotNo: XmlImportTableItemMetadata;
  warrantyType: XmlImportTableItemMetadata;
  deficiencies: XmlDeficiency[];
}

// export interface XmlDeficiencyTableItem {
//   description: XmlImportTableItemMetadata;
//   location: XmlImportTableItemMetadata;
//   level: XmlImportTableItemMetadata;
//   room: XmlImportTableItemMetadata;
//   category: XmlImportTableItemMetadata;
// }

export interface XmlImportTableItemMetadata {
  value: string | Date | null;
  isValid: boolean;
}

export type CategoryLocationsMap = Record<string, WarrantyLocation[]>;

export type LotDeficiencyCreateObj = Pick<
  LotDeficiency,
  | 'lotId'
  | 'warrantyTypeId'
  | 'deficiencyId'
  | 'locationId'
  | 'detailDescription'
  | 'assignedToTechnician'
  | 'assignedToTrade'
  | 'scheduledDate'
  | 'status'
  | 'isEscalated'
> & { keyImages: string[]; enableInstantEmail: boolean };
export interface AssignDeficiencyPayload {
  lotDeficiencyIds: string[];
  assignments: DeficiencyAssignment[];
  scheduledDate?: Date | null;
  enableInstantEmail: boolean;
  detailDescription?: string;
}
export interface DeficiencyAssignment {
  name?: string;
  assignedToTrade?: string | null;
  assignedToTechnician?: string | null;
}
